'use strict';

import React from 'react';

import { OnSchedUtils } from "../../utils";

import Title             from "../../components/Title/Title";
import List             from "../../components/List/List";


const Resources = element => 
  <>
    <Title element={element} title={OnSchedUtils.Internationalize(element, 'consumer_resources_title')}/>

    <List
      properties={element.options.properties ? element.options.properties : ['{name}']} 
      image="imageUrl" 
      element={element} 
      event="clickResource" 
    />
  </>

export default Resources
